import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface DasRPAlertSvgIconProps extends SvgIconProps {
  disabled?: boolean;
}

const DasRPAlertSvgIcon = ({ ...props }: DasRPAlertSvgIconProps) => (
  <SvgIcon
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/SvgIcon"
    {...props}
  >
    <path
      d="M12 29C13.1046 29 14 29.8954 14 31C14 32.1046 13.1046 33 12 33C10.8954 33 10 32.1046 10 31C10 29.8954 10.8954 29 12 29ZM28 29C29.1046 29 30 29.8954 30 31C30 32.1046 29.1046 33 28 33C26.8954 33 26 32.1046 26 31C26 29.8954 26.8954 29 28 29ZM30 17H25.4961L21.7461 20L25.6816 23.1484L26.8076 24.0488L25.6338 24.8877L22.6748 27.001H28V25.001H30V28.7686C29.469 28.2924 28.7694 28 28 28C26.3434 28.0001 25.0003 29.3434 25 31V31.001H15V31C14.9997 29.3434 13.6567 28 12 28C11.2306 28 10.531 28.2923 10 28.7686V27.001H17.3242L14.3662 24.8877L13.1924 24.0488L14.3184 23.1484L18.2529 20L14.5039 17H10V7H30V17ZM16.8086 23.9502L20 26.2295L23.1914 23.9502L20 21.3965L16.8086 23.9502ZM20 18.6025L22.0039 17H17.9961L20 18.6025ZM12 15H19V13H12V15ZM21 15H28V13H21V15ZM12 11H19V9H12V11ZM21 11H28V9H21V11Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default DasRPAlertSvgIcon;
